import { render, staticRenderFns } from "./UpdateTask.vue?vue&type=template&id=64308a86&"
import script from "./UpdateTask.vue?vue&type=script&lang=js&"
export * from "./UpdateTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports